import React, { useState, useEffect } from 'react';
import { API } from '../config';

export default function RateUsModal({ onClose }) {
  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [text, setText] = useState('');
  const [companyOrTitle, setCompanyOrTitle] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');
  const userType = localStorage.getItem('user_type');

  // Pre-fill existing review
  useEffect(() => {
    if (!token) return;
    fetch(`${API}/reviews/my-review`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d) { setRating(d.rating); setText(d.review_text); setCompanyOrTitle(d.company_or_title || ''); }
      }).catch(() => {});
  }, []);

  const handleSubmit = async () => {
    if (!rating) { setError('Please select a star rating.'); return; }
    if (text.trim().length < 10) { setError('Please write at least 10 characters.'); return; }
    setSubmitting(true); setError('');
    try {
      const res = await fetch(`${API}/reviews/`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating, review_text: text.trim(), company_or_title: companyOrTitle || null }),
      });
      if (!res.ok) throw new Error((await res.json()).detail || 'Failed');
      setDone(true);
      setTimeout(onClose, 2000);
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0, padding: 0, border: 'none', fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <i className="fas fa-star" style={{ color: '#f59e0b' }}></i> Rate JobLinked AI
          </h2>
          <button className="modal-close" onClick={onClose}><i className="fas fa-times"></i></button>
        </div>

        {done ? (
          <div className="modal-body" style={{ textAlign: 'center', padding: '2rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>🎉</div>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>Thank you!</h3>
            <p style={{ color: 'var(--text-muted)' }}>Your review helps us improve JobLinked AI.</p>
          </div>
        ) : (
          <>
            <div className="modal-body">
              <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '1.25rem' }}>
                How has your experience been with JobLinked AI? Your feedback helps us grow.
              </p>

              {/* Stars */}
              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem', justifyContent: 'center' }}>
                {[1,2,3,4,5].map(s => (
                  <i
                    key={s}
                    className={`fas fa-star`}
                    style={{
                      fontSize: '2rem',
                      cursor: 'pointer',
                      color: s <= (hovered || rating) ? '#f59e0b' : 'var(--border-strong)',
                      transition: 'color 0.1s',
                    }}
                    onMouseEnter={() => setHovered(s)}
                    onMouseLeave={() => setHovered(0)}
                    onClick={() => setRating(s)}
                  />
                ))}
              </div>
              {rating > 0 && (
                <p style={{ textAlign: 'center', fontSize: '0.82rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
                  {['','Poor','Fair','Good','Great','Excellent!'][rating]}
                </p>
              )}

              <div className="form-group">
                <label className="form-label">{userType === 'RECRUITER' ? 'Company Name' : 'Job Title / Role'} <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(optional)</span></label>
                <input className="form-control" type="text"
                  placeholder={userType === 'RECRUITER' ? 'e.g. ABSA Bank' : 'e.g. Data Scientist'}
                  value={companyOrTitle} onChange={e => setCompanyOrTitle(e.target.value)} />
              </div>

              <div className="form-group">
                <label className="form-label">Your Review *</label>
                <textarea className="form-control" rows="4"
                  placeholder="Tell us about your experience..."
                  value={text} onChange={e => setText(e.target.value)} />
                <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{text.length} / 500</span>
              </div>

              {error && <div className="alert alert-error" style={{ marginBottom: 0 }}><i className="fas fa-exclamation-circle"></i> {error}</div>}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSubmit} disabled={submitting || !rating}>
                {submitting ? <><i className="fas fa-spinner fa-spin"></i> Submitting...</> : <><i className="fas fa-paper-plane"></i> Submit Review</>}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
